import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"

import { Link } from "gatsby"

import CircleText from "../../components/theme-2/CircleText"
import NameComponent from "../../components/theme-2/Name"
import FeatherIcon from "../../components/featherIcon"

import { motion } from "framer-motion"

import { getTheme } from "../../components/themer"

const Theme2Index = () => {
  let theme = getTheme()

  return (
    <Layout>
      <SEO title="Home" keywords={[`addison schultz`]} />
      <div
        className={"mainWrapper"}
        style={{
          backgroundColor: theme.bgColor,
        }}
      >
        <div className={"circleWrapper"}>
          <CircleText fillColor={theme.textColor} />
        </div>
        <div className={"nameWrapper"}>
          <NameComponent bgColor={theme.bgColor} textColor={theme.textColor} />
        </div>
        <Link to="/speaking">
          <motion.div
            className={"page2Link"}
            style={{ backgroundColor: theme.textColor }}
          ></motion.div>
        </Link>
        <div
          className={"infoWrapper"}
          style={{
            color: theme.textColor,
          }}
        >
          <h3>
            Frontend developer and designer, occasional writer, and music maker
            living in Amsterdam
          </h3>
          <br />
          <br />
          <br />
        </div>
        <div className={"footerWrapper"}>
          <FeatherIcon
            name="github"
            style={{ margin: 10 }}
            color={theme.textColor}
            href={"https://github.com/addisonschultz"}
          />
          <FeatherIcon
            name="framer"
            style={{ margin: 10 }}
            color={theme.textColor}
            href={"https://framer.com"}
          />
          <FeatherIcon
            name="mail"
            style={{ margin: 10 }}
            color={theme.textColor}
            href={"mailto:addisonschultz0@gmail.com?subject=Hey!"}
          />
          <FeatherIcon
            name="twitter"
            style={{ margin: 10 }}
            color={theme.textColor}
            href={"https://twitter.com/AddisonSchultz"}
          />
          <FeatherIcon
            name="book"
            style={{ margin: 10 }}
            color={theme.textColor}
            href={"https://medium.com/@addisonschultz"}
          />
          <FeatherIcon
            name="linkedin"
            style={{ margin: 10 }}
            color={theme.textColor}
            href={"https://www.linkedin.com/in/addisonschultz/"}
          />
        </div>
      </div>
    </Layout>
  )
}

export default Theme2Index
